export const CONSULTANT_ROLE_CHANGE = 1;
export const BUY_PLANEJADOR_FRANCHISE = 2;
export const BUY_EXPANSAO_FRANCHISE = 3;